import { styled } from '@mui/material/styles';

import { Heading } from '../Heading';

export const StyledHeading = styled(Heading)`
    margin-right: 3rem;
    margin-left: 3rem;
`;
